import { useEffect, useState } from 'react'

const useHotkeys = hotkeys => {
    
    const [isMounted, setIsMounted] = useState(false)
    
    useEffect(() => {
        
        setIsMounted(true)
        
        // @todo warn if multiple hotkeys set with the same key & modifier
        const seenKeys = hotkeys.reduce((acc, it) => {
            
            const uniqueKey = `${it.key}:${it.modifier ?? 0}`
            const seenCount = acc[uniqueKey] ?? 0
            
            return {
                ...acc,
                [uniqueKey]: seenCount + 1, 
            }
            
        }, {})
        
        const duplicateKeys = Object.keys(seenKeys)
            .filter(it => seenKeys[it] > 1)
        
        if (duplicateKeys.length)
            duplicateKeys.forEach(it => console.error('useHotKeys: duplicate key defined for', it))
        
        const handleKeyDown = e => {
            
            const matchedKeys = hotkeys.filter(it => {
                
                if (e.key === it.key) {
                    
                    // If a modifier is set, confirm that matches also
                    if (it.modifier)
                        return e[it.modifier]
                    
                    // If no modifier set, still return true bc the hotkey matched
                    return true
                    
                }
                
                return false
                
            })
            
            // We must pass hotkeys in a priority order
            // i.e. if we have a hotkey for "Enter" and
            // another hotkey for "Shift + Enter", this
            // last one must be the first on hotkeys array
            if (matchedKeys.length) {
                e.preventDefault()
                matchedKeys[0].handler(e)
            }
            
        }
        
        if (isMounted)
            window.addEventListener('keydown', handleKeyDown)
        
        return () => window.removeEventListener('keydown', handleKeyDown)
        
    }, [isMounted, hotkeys])
    
}

export default useHotkeys
